<style lang="less" scoped>
.contian {
    // display: flex;
    height: 600px;
}
.left {
    display: inline-block;
    height: 100%;
    width: 66%;
    // flex: 2;
    // border: solid 1px #515a6e;
    div {
        height: 100%;
    }
}
.right {
    float: right;
    display: inline-block;
    height: 100%;
    width: 33%;
    .right-contain {
      height: 100%;
      // flex: 1;
      display: flex;
      flex-direction: column;
      margin-left: 10px;
      // border: solid 1px #515a6e;
      .echarts-contain {
        position: relative;
        .title-contain {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          display: flex;
          align-items:center;
          justify-content:center;
          p {
            margin-bottom: 0px;
            font-size: 14px;
            font-weight: normal;
            text-align: center;
          }
        }
      }      
    }

}
.exhibition-contain {
  margin: 12px 0;
  padding: 15px 0;
  background: #fcfcfc;
  .money {
      margin-bottom: 0px;
      padding: 0 24px;
      height: 36px;
      color: #606266;
      font-weight: 600;
      text-align: left;
      .num {
        line-height: 36px;
        font-size: 24px;
      }
  }
  .title {
    margin-bottom: 0px;
    padding: 0 24px;
    height: 22px;
    line-height: 22px;
    font-size: 14px !important;
    font-weight: 400;
    color: #606266;
  }
}
</style>
<template>
  <div style="margin: 0 5px">
    <div style="text-align:right">
      <IconMark />
      <Select
        :value="params.year"
        style="width:200px;padding: 0 12px"
        @on-change="changeYear"
      >
        <Option
          v-for="item in yaerList"
          :key="item"
          :value="item"
        >
          {{ item }}
        </Option>
      </Select>
    </div>
    <div class="contian">
      <Spin
        v-if="loading.getHistoryDataLoading"
        size="large"
        fix
      />
      <div class="left">
        <div ref="echarts-cash" />
      </div>
      <div class="right">
        <div class="right-contain">
          <div
            class="echarts-contain"
            style="height:400px"
          >
            <div 
              ref="cash-circle"
              style="height:100%;width:100%"
            />
            <div
              v-show="historyData&&historyData.users"
              class="title-contain"
            >
              <div class="title">
                <p>付费用户</p>
                <p>{{ pay_user }}</p>
              </div>
            </div> 
            <div class="exhibition-contain">
              <p class="money">
                <span class="num">¥ {{ general_income }}</span>
                <span style="margin-left:10px;font-size:16px">万</span>
              </p>
              <p class="title">
                现金总金额（扣除优惠券）
              </p>
            </div>    
            <div class="exhibition-contain">
              <p class="money">
                <span class="num">¥ {{ general_discount }}</span>
                <span style="margin-left:10px;font-size:16px">万</span>
              </p>
              <p class="title">
                折扣总金额
              </p>
            </div>     
          </div>
        </div>
      </div>
    </div>  
    <div style="margin: 20px 0;width: 100%;">
      <p>单位：元</p>
      <Table
        :columns="historyColumns"
        :data="historyTableData" 
        border
      />
    </div>
  </div>
</template>
<script>
  import echarts from 'echarts'
  import "echarts/lib/component/markPoint"
  import { mapActions, mapState, mapMutations, mapGetters } from 'vuex'
  import { cash_fields_fun, total_fun, cash_cicles_fun, subject_hash_color, production_keys, dev_keys } from './historyData_fields'
  import IconMark from './IconMark.vue'
  import { NAME_SPACE } from './../constants'
  import { formattingNumber } from './../utils'
  export default {
    components: {
      IconMark
    },
    props: {
      rootTeamsHash: {
        type: Object,
        default: () => ({})
      }
    },
    data() {
      this.cash = null
      this.cash_circle = null
      this.cash_bar_options = null
      this.cash_circle_options = null
      return {
        params: {
          year: moment().year()
        }
      }
    },
    computed:{
      ...mapGetters({
        teams_hash: 'async/product_teams_hash',
        //  teams: 'async/root_teams',
      }),
      ...mapState(NAME_SPACE, {
        loading:'loading',
        changeTag: 'changeTag',
        sourceHistoryData: 'historyData',
      }),
      historyData() { // 将金额数据处理成以万单位的数
        if (!this.sourceHistoryData) {
          return this.sourceHistoryData
        }
        const new_historyData = {
          discount:Number(this.sourceHistoryData.discount || 0) / 10000,
          income: Number(this.sourceHistoryData.income || 0) / 10000,
          users:this.sourceHistoryData.users && {...this.sourceHistoryData.users}
        }
        new_historyData.line_data = []
        this.sourceHistoryData.line_data && this.sourceHistoryData.line_data.forEach((item, index) => {
          const new_current = new_historyData.line_data[index] = {}
          Object.keys(item).forEach(key => {
            if (key === 'month') {
              new_current[key] = item[key]
            } else {
              new_current[key] = (Number(item[key] || 0) / 10000).toFixed(0)
            }
          })
        })
        return new_historyData
      },
      pay_user() {
        return formattingNumber(this.historyData && this.historyData.users && this.historyData.users.user) || '-'
      },
      general_income() {
        return formattingNumber(this.historyData && this.historyData.income, 0) || '--'
      },
      general_discount() {
        return formattingNumber(this.historyData && this.historyData.discount, 0) || '--'
      },
      historyColumns() {
        if (!this.sourceHistoryData) {
          return []
        }
        const arr = []
        this.sourceHistoryData.line_data.forEach(item => {
          Object.keys(item).forEach(key => {
            if (!arr.includes(key) && key !== 'month') {
              arr.push(key)
            }
          })
        })
        const columns = arr.filter(key => !!this.teams_hash[key]).map(key => {
          return ({
            title:this.teams_hash[key].name,
            key,
            align:'right',
            minWidth: 90,
            render(h, { row }) {
              let num = Number(row[key]) || 0
              num = formattingNumber(num, 1)
              return <span>{Math.abs(num) === 0 ? 0 : num}</span>
            }
          })
        })
        return [
          {
            title:'月份',
            key:'month',
            align:'center',
            minWidth: 100,
          }, ...columns, {
            title:'总计',
            key:'sum',
            align:'right',
            minWidth: 100,
            render(h, { row }) {
              let num = Number(row['sum']) || 0
              num = formattingNumber(num, 1)
              return <span>{Math.abs(num) === 0 ? 0 : num}</span>
            }
          }]
      },
      historyTableData() {
        if (!this.sourceHistoryData) {
          return []
        }
        const total_sum = {
          month:'总计',
          sum:0
        }
        const arr = this.sourceHistoryData.line_data.map(item => {
          let sum = 0
          Object.keys(item).forEach(key => {
            if (key !== 'month') {
              if (total_sum[key] === undefined) {
                total_sum[key] = 0
              }
              total_sum[key] = math.eval(`${total_sum[key]} + ${item[key]}`).toFixed(2)
              sum = math.eval(`${sum} + ${item[key]}`).toFixed(2)
            }
          })
          // sum = Number(sum).toFixed(1) // 每个月的所有项目的收入和
          total_sum.sum = math.eval(`${total_sum.sum} + ${sum}`).toFixed(2)
          return {
            ...item,
            sum,
            month: Number((item.month + '').slice(-2)) + '月'
          }
        })
        return arr.concat(total_sum)
      },
      yaerList() {
        const arr = []
        const current = Number(moment().year())
        for (let year = 2020; year <= current; year++) {
          arr.push(year)
        }
        return arr
      }
    },
    watch:{
      'changeTag.historyChangeIndex'() {
        this.$nextTick(() => {
          this.getDataBar()
          this.getDataCircle()
        })
        /* resizeCall */
      },    
    },
    mounted() {
      this.cash = echarts.init(this.$refs['echarts-cash'], 'walden')
      this.cash_circle = echarts.init(this.$refs['cash-circle'], 'walden')
      /* 初始化 样式 */
      /* 点击legend的回调 */
      this.cash.on('legendselectchanged', this.legend_select_changed)
      /* 数据初始化 */
      this.addEchartsResize(this.cash.resize)
      this.addEchartsResize(this.cash_circle.resize)
    },
    methods: {
      resizeEchart() {
        this.resizeCall([this.cash.resize, this.cash_circle.resize])
      },
      changeYear(year) {
        this.params.year = year
        this.getData()
      },
      // 获取数据
      getData(params) {
        this.getHistoryData(params || this.params)
      },
      // 点击legend的回调
      legend_select_changed({ name } = {}) { // 回调
        const isCheckAll = name === '全选'
        if (isCheckAll) {
          this.cash.clear()
          this.getDataBar()
          return
        }
        const option = this.cash.getOption() // 获取当前echarts实例的参数
        const sourceData = option.series.filter((item) => item.name !== '全选')
        const cash_field = this.cash_bar_options 
        let arr = new Array(cash_field.xAxis.data.length).fill(0)
        sourceData.forEach(item => {
          if (isCheckAll) { // 全选
            item.data.forEach((child_data, index) => {
              arr[index] += (Number(child_data) || 0)
            })
          }
          if (!isCheckAll && item.name === name) { // 点击单个
            item.data.forEach((child_data, index) => {
              arr[index] += (Number(child_data) || 0)
            })
          }
        })
        Object.keys(option.legend[0].selected).forEach(key => {
          if (isCheckAll) {
            option.legend[0].selected[key] = key === '全选' ? false : true
          } else {
            option.legend[0].selected[key] = name === key ? true : false
          }
        })
        arr = arr.map(item => Number(item.toFixed(0)))
        this.cash.setOption({...option, series: [...sourceData, total_fun(arr)]});
      },
      // bar图
      getDataBar() {
        if (!this.historyData) return ;
        if (!this.cash_bar_options) {
          this.cash_bar_options = cash_fields_fun()
        }
        this.cash_bar_options.xAxis.data = this.historyData.line_data.map(item => Number(item.month.toString().slice(-2)) + '月')
        // [10, 1, 5, 18, 8, 24, 0] 
        const y_data_type_arr = process.env.NODE_ENV === "production" ? production_keys : dev_keys
        // if (this.historyData.line_data) {
        //   this.historyData.line_data.forEach(item => {
        //     Object.keys(item).forEach(key => {
        //       if (key !== 'month' && !y_data_type_arr.includes(key)) {
        //         y_data_type_arr.push(key)
        //       }
        //     })
        //   })
        // }
        const arr = new Array(this.cash_bar_options.xAxis.data.length).fill(0)
        const series = []
        y_data_type_arr.forEach((item, index) => {
          const name = (this.rootTeamsHash[item] || {}).name
          let color = subject_hash_color[item]
          if (process.env.NODE_ENV !== "production") {
            color = subject_hash_color[production_keys[index]]
          }
          series.push({
            name: name,
            _key: item,
            type: 'bar',
            stack: '总量',
            barWidth: '40%',
            label: {
              show:false
            },
            color,
            data:[]
          })
        })
        this.cash_bar_options.legend.data = series.map(item => item.name)
        this.cash_bar_options.legend.selected = this.cash_bar_options.legend.data.reduce((total, item) => {
          total[item] = true
          return total
        }, {})
        this.cash_bar_options.legend.data = [...this.cash_bar_options.legend.data, {
          name: '全选',
          // 强制设置图形为圆。
          icon: 'circle',
        }
        ]
        this.cash_bar_options.yAxis.name = '单位：万'
        this.historyData.line_data.forEach((item, index) => {
          series.forEach(_item => {
            _item.data.push(Number(item[_item._key]))
          })
          arr[index] = Object.keys(item).filter(child_item => child_item !== 'month').reduce((total, key) => {
            return total + (Number(item[key]) || 0)
          }, 0)
          arr[index] = (arr[index] || 0).toFixed(0)
        })
        this.cash.setOption({...this.cash_bar_options, series:[...series, total_fun(arr)]})
      },
      // 环形图
      getDataCircle() {
        if (!this.historyData) {
          return
        }  
        if (!this.cash_circle_options) {
          this.cash_circle_options = cash_cicles_fun()
        }
        this.cash_circle_options.series[0].name = '付费用户'
        this.cash_circle_options.series[0].data = [
          {
            name:'新用户',
            value: this.historyData.users.new_user,
            label: {
              color: '#000000',
              formatter(params) {
                return '新用户：\n' + formattingNumber(params.value) || 0
              }
            },
            itemStyle: {
              color: '#ACE1CF'
            }
          },
          {
            name:'老用户',
            value:this.historyData.users.old_user,
            label: {
              color: '#000000',
              formatter(params) {
                return '老用户：\n' + formattingNumber(params.value) || 0
              }
            },
            itemStyle: {
              color: '#B9DBF8'
            }
          },
        ]
        this.cash_circle.setOption(this.cash_circle_options)
      },
      ...mapMutations(NAME_SPACE, [
        'addEchartsResize',
        'resizeCall'
      ]),
      ...mapActions(NAME_SPACE, [
        'getHistoryData',
      ]),
    },
  }
</script>
